// SocialHub.jsx
import { Box, Paper, Typography } from "@mui/material";
import SearchBox from "../quizzes/SearchBox";
import { useState, useEffect } from "react";
import Publish from "./Publish";
import { getCategoryPathByTitle } from "./categoryUtil";
import { config } from "../Const";
import { executeFetchAsync } from "../Util";

export default function SocialHub(props) {
    const [entity, setEntity] = useState(null);
    const [detailedEntity, setDetailedEntity] = useState(null);

    const handleEntitySelected = (entity) => {
        setEntity(entity);
    };

    // Fetch detailed entity whenever entity?.id changes
    useEffect(() => {
        if (!entity?.id) {
            setDetailedEntity(null);
            return;
        }

        let cancelled = false;
        const id = entity.id;
        const apiUrl = `${config.SERVER_URL}/api/v1/admin/quiz/${id}`;

        (async () => {
            try {

                // executeFetchAsync should return a Promise
                // adjust signature if your executeFetchAsync requires extra args
                const result = await executeFetchAsync(apiUrl, "get");

                if (cancelled) return;



                setDetailedEntity(result);
            } catch (err) {
                if (cancelled) return;
            } finally {
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [entity?.id]);

    return (
        <Box>
            <Box sx={{ width: "100%", display: "flex", p: "20px", justifyContent: "center" }}>
                <Box sx={{ width: "500px" }}>
                    <SearchBox
                        endPoint={"page"}
                        onEntitySelected={handleEntitySelected}
                        resultMappingFunction={(r) => {
                            return {
                                label: r.label,
                                id: r.id,
                                type: r.type,
                                seoTitle:
                                    r.type === "CATEGORY" ? getCategoryPathByTitle(r.label.toLowerCase()) : r.seoTitle,
                            };
                        }}
                    />
                </Box>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Paper elevation={10} sx={{ borderRadius: "10px", width: "70%", padding: "40px" }}>
                    {entity ? (
                        <>
                            <Publish seoTitle={entity.seoTitle} type={entity.type} detailedEntity={detailedEntity} />


                        </>
                    ) : (
                        <Typography variant="body1" color="text.secondary">
                            Select a page from the search box to manage social posts.
                        </Typography>
                    )}
                </Paper>
            </Box>
        </Box>
    );
}
